import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAppliedJobapiQuery } from "../Store/Middleware/api/getAppliedJobAPI";
import Hero from "../Components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import WorkOffIcon from "@mui/icons-material/WorkOff";
import { Box, CircularProgress, Typography } from "@mui/material";
import Cookies from "js-cookie";
import axios from "axios";

const AppliedJob = () => {
  const nav = useNavigate();
  const [appliedJobs, setAppliedJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAppliedJobs = async () => {
    const token = Cookies.get("authToken");
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/user/applied/all-job`, {
        headers: {
          authorization: token,
        },
      })
      .then((response) => {
        if (response?.status === 401) {
          localStorage.clear();
          Cookies.remove("_secure_ARJ_");
          window.location.href = "/login";
        }
        setAppliedJobs(response.data.message);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAppliedJobs();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Applied Jobs | Career Portal";
  }, []);

  return (
    <section className="openPositionSection">
      <Hero heading={"Applied Jobs"} subHeading={""} />
      {loading ? (
        <Box
          sx={{
            height: "50vmin",
            background: "#fff",
            display: "grid",
            placeItems: "center",
          }}
        >
          <CircularProgress
            sx={{
              "& svg": {
                color: "#38c4ec",
              },
            }}
          />
        </Box>
      ) : appliedJobs === 0 ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "50vmin",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            background: "#fff",
          }}
        >
          <WorkOffIcon sx={{ fontSize: "25vmin", color: "#D3D3D3" }} />
          <Typography sx={{ fontSize: "2.5vmin", color: "#D3D3D3" }}>
            No Jobs Available
          </Typography>
        </Box>
      ) : (
        <div className="appliedJobsWrapper">
          {appliedJobs.map((item, index) => {
            return (
              <div key={index} className="appliedJobTile">
                <div className="appliedTitleWrapper">
                  <p className="appliedTitle">{item.title}</p>
                  <p className="appliedName">{item.name}</p>
                </div>
                <div className="appliedDate">
                  <CheckCircleIcon sx={{ color: "#165DFF" }} />
                  <span className="appliedDateText">
                    Applied on {moment(item.applied_date).format("DD/MM/YYYY")}
                  </span>
                </div>
                <button
                  onClick={() =>
                    nav(`/authPage/jobdetails/${item.joborder_id}`)
                  }
                  className="appliedViewButton"
                >
                  View Full Detail <ChevronRightIcon />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default AppliedJob;
